export default {
    tooltip: 'A copy of the trend is saved as a Company Trend and is available for editing.'
}
